<template>
  <div id="customer-dashboard" ref="customerDashboard" :style="cssVars">
    <div class="filter-box">
      <div class="filter-input">
        <v-autocomplete outline flat dense hide-details height="38" :items="channelList" v-model="filter.channel"
                        placeholder="Channel" item-text="text"
                        value="all"
                        item-value="value" :append-icon='`${filter.channel ? "" : $vuetify.icons.dropdown}`' @change="onRefresh">
        </v-autocomplete>
      </div>
      <div class="filter-input">
        <DatePickerOutline
            flat
            v-model="filter.from"
            :max="filter.to"
            hide-details
            append-icon=""
            prepend-inner-icon=""
            @change="onRefresh"
        />
      </div>
      <div class="filter-input">
        <DatePickerOutline
            flat
            hide-details
            append-icon="mdi-calendar"
            v-model="filter.to"
            :min="filter.from"
            :max="today"
            prepend-inner-icon=""
            @change="onRefresh"
        />
      </div>
      <div class="d-flex align-center justify-center btn-refresh" @click="onRefresh">
        <icon-base icon-color="#6B6F80" icon-hover-color="#6B6F80" style="padding-right: 6px">
          <icon-refresh/>
        </icon-base>
        <span>Refesh</span>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <v-btn icon @click="onExcelDownload" v-on="on">
            <img width="20" height="20" src="@/assets/icons/excel.png"/>
          </v-btn>
        </template>
        <span>{{$t('exportExcel')}}</span>
      </v-tooltip>
    </div>
    <div class="customer-dashboard-content">
      <div class="d-flex customer-dashboard-other">
        <div class="customer-dashboard-total-served">
          <span>{{ overview.totalAgentServed }}</span>
          <span>Served Sessions</span>
        </div>
        <div class="customer-dashboard-total-supporting">
          <span>{{ overview.supporting }}</span>
          <span>Supporting sessions</span>
        </div>
        <div class="customer-dashboard-total-waiting">
          <span>{{ overview.waiting }}</span>
          <span>Waiting sessions</span>
        </div>
      </div>
      <div class="customer-dashboard-other">
        <div class="customer-dashboard-total-auto-mad">
          <span>{{ overview.totalServedAutoMAD }}</span>
          <span>Auto MAD sessions</span>
        </div>
        <div class="customer-dashboard-total-auto-mad">
          <span>{{ overview.totalServedAutoMADUnAssigned }}</span>
          <span>Not assigned</span>
        </div>
        <div class="customer-dashboard-total-auto-mad">
          <span>{{ overview.totalServedAutoMADLastMsgAgent }}</span>
          <span>Last replied Agent</span>
        </div>
        <div class="customer-dashboard-total-auto-mad">
          <span>{{ overview.totalServedAutoMADLastMsgUser }}</span>
          <span>Last replied User</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconRefresh from "components/icons/IconRefresh";
import IconBase from "components/icons/IconBase";
import {sync} from "vuex-pathify";
import $const from "@/utils/const";
import upperFirst from "lodash/upperFirst";
import DatePickerOutline from "components/custom/DatePickerOutline";
import moment from "moment";
import {mapActions, mapState} from "vuex";
import * as excelJS from "exceljs";
import { saveAs } from "file-saver";
export default {
  name: "CustomerDashboard",
  components: {IconRefresh, IconBase, DatePickerOutline},
  data() {
    return {
      isMounted: false,
      today: moment().format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapState('customer', ['overview']),
    filter: sync('customer/overviewFilter'),
    cssVars() {
      if (this.isMounted) {
        return {
          '--customer-dashboard-font-size': `${this.$refs.customerDashboard.clientWidth / 60}px`
        }
      }
      return {
        '--customer-dashboard-font-size': '0px'
      }
    },
    channelList() {
      return $const.ALL_CHAT_CHANNELS.map(o => {
        return {text: upperFirst(this.$t(o)), value: o}
      })
    },
    channels() {
      if (this.filter.channel === 'all' || this.filter.channel === '') {
        return $const.ALL_CHAT_CHANNELS.join()
      }
      return this.filter.channel
    }
  },
  mounted() {
    this.isMounted = true
    this.refreshInterval()
  },
  methods: {
    ...mapActions('customer', ['getOverview']),
    onRefresh() {
      this.getOverview(this.channels)
    },
    refreshInterval() {
      this.onRefresh()
      setTimeout(()=> {
        this.refreshInterval()
      }, 300*1000)
    },
    onExcelDownload() {
      const workbook = new excelJS.Workbook();
      workbook.created = new Date();
      workbook.modified = new Date();

      let sheet = workbook.addWorksheet("Report");
      sheet.getRow(1).values = ["Criteria","Value"];
      sheet.columns = [
        { key: "key", width: 100, alignment: {horizontal: "left"} },
        { key: "value", width: 30 },
      ];
      const data = [
        {
          key: "Served Sessions",
          value: this.overview.totalAgentServed
        },
        {
          key: "Supporting sessions",
          value: this.overview.supporting
        },
        {
          key: "Waiting sessions",
          value: this.overview.waiting
        },
        {
          key: "Auto MAD sessions",
          value: this.overview.totalServedAutoMAD
        },
        {
          key: "Not assigned",
          value: this.overview.totalServedAutoMADUnAssigned
        },
        {
          key: "Last replied Agent",
          value: this.overview.totalServedAutoMADLastMsgAgent
        },
        {
          key: "Last replied User",
          value: this.overview.totalServedAutoMADLastMsgUser
        }
      ]
      sheet.addRows(data);

      const row = sheet.getRow(1);
      row.eachCell((cell, rowNumber) => {
        sheet.getColumn(rowNumber).alignment = {
          vertical: "middle",
        };
        sheet.getColumn(rowNumber).font = { size: 14, family: 2 };
      });

      workbook.xlsx.writeBuffer().then(function(buffer) {
        const blob = new Blob([buffer], { type: "application/xlsx" });
        saveAs(blob, "Overview Report.xlsx");
      });
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 38px;
}

::v-deep.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid #D9D9D9 !important;
}

::v-deep.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
  margin-top: 0 !important;
}

::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: white !important;
}

::v-deep.v-text-field .v-input__append-inner {
  margin-top: 8px !important;
}

::v-deep input {
  font-size: 14px;
}
::v-deep i {
  font-size: 20px !important;
}
#customer-dashboard {
  background-color: white;
  border-radius: 5px;
  margin: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: var(--customer-dashboard-font-size);

  .filter-box {
    background-color: white;
    height: 38px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    align-items: center;
    .filter-input {
      max-width: 140px;
    }
    .btn-refresh {
      padding-left: 10px;
      cursor: pointer;
      span {
        font-size: 12px;
        color: #6B6F80
      }
    }
  }

  .customer-dashboard-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    padding: 0 25px;

    .customer-dashboard-total-served {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .customer-dashboard-total-served span:first-of-type {
      color: #45C08C;
      font-size: 6.450em;
      font-weight: bold;
      line-height: 1.2;
    }

    .customer-dashboard-total-served span:last-of-type {
      color: #141519;
      font-size: 1.935em;
      line-height: 1.2;
    }

    .customer-dashboard-other {
      width: 100%;
      display: flex;
      gap: 30px;
      align-items: flex-end !important;
      .customer-dashboard-total-supporting {
        display: flex;
        flex-direction: column;
      }

      .customer-dashboard-total-supporting span:first-of-type {
        color: #E9BF2E;
        font-size: 3.87em;
        font-weight: bold;
        line-height: 1.2;
      }

      .customer-dashboard-total-supporting span:last-of-type {
        color: #141519;
        font-size: 1.935em;
        line-height: 1.2;
      }

      .customer-dashboard-total-waiting {
        display: flex;
        flex-direction: column;
      }

      .customer-dashboard-total-waiting span:first-of-type {
        color: #ED6666;
        font-size: 3.87em;
        font-weight: bold;
        line-height: 1.2;
      }

      .customer-dashboard-total-waiting span:last-of-type {
        color: #141519;
        font-size: 1.935em;
        line-height: 1.2;
      }

      .customer-dashboard-total-auto-mad {
        display: flex;
        flex-direction: column;
      }

      .customer-dashboard-total-auto-mad span:first-of-type {
        color: #4375F4;
        font-size: 3.87em;
        font-weight: bold;
        line-height: 1.2;
      }

      .customer-dashboard-total-auto-mad span:last-of-type {
        color: #141519;
        font-size: 1.935em;
        line-height: 1.2;
      }
    }
  }
}

</style>
